import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";
import WordReveal from "@/components/WordReveal";
import { cases } from "@/data/cases";
import { useSeo } from "@/lib/seo";
import { breadcrumb } from "@/lib/structuredData";

const SECTORS = ["All", "Lighting", "Furniture", "Home décor", "Textile"];

export const Work = () => {
  useSeo({
    title: "Selected Work · Case Studies",
    description:
      "Documented case studies: 12,000 brass pendants, FSC dining range, blue-pottery 99.4% intact landing, 3-season hand-blown glass programme.",
    path: "/work",
    jsonLd: breadcrumb([
      { name: "Home", path: "/" },
      { name: "Work", path: "/work" },
    ]),
    jsonLdId: "work-jsonld",
  });

  const [filter, setFilter] = useState("All");

  const visible = useMemo(() => {
    if (filter === "All") return cases;
    return cases.filter((c) => c.sector === filter);
  }, [filter]);

  return (
    <div data-testid="work-page">
      <header className="page-head wrap">
        <Reveal as="p" className="eyebrow">Evidence · Selected work</Reveal>
        <WordReveal as="h1" text="Documented from drawing to dock." stagger={70} />
        <Reveal as="p" className="lede" delay={200}>
          Four orders, four problems, four documented outcomes. Filter by category to see the
          chain in your sector.
        </Reveal>
      </header>

      <section className="wrap">
        <div className="filter-bar" style={{ marginTop: "3rem" }} data-testid="work-filters">
          {SECTORS.map((s) => (
            <button
              key={s}
              className={`chip ${filter === s ? "active" : ""}`}
              onClick={() => setFilter(s)}
              data-testid={`work-filter-${s.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            >
              {s}
            </button>
          ))}
        </div>

        <div className="work-grid" data-testid="work-grid">
          {visible.map((c) => (
            <Reveal key={c.slug}>
              <Link
                to={`/work/${c.slug}`}
                className="card tilt"
                data-testid={`work-grid-card-${c.slug}`}
              >
                <div className="plate">
                  <img src={c.image} alt={`${c.title} — case study, Asia Sourcing`} width="800" height="600" loading="lazy" />
                  <span className="tag">{c.tag}</span>
                </div>
                <h3>{c.title}</h3>
                <p className="spec">{c.spec}</p>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="cta wrap">
        <Reveal as="p" className="eyebrow">Start an enquiry</Reveal>
        <Reveal as="h2" className="display">Your category, documented.</Reveal>
        <Reveal className="row">
          <Link to="/contact" className="btn btn-fill btn-lg" data-testid="work-cta">
            Send an enquiry
          </Link>
        </Reveal>
      </section>
    </div>
  );
};

export default Work;
